import { Helmet } from "react-helmet"

const Head = () => {
  return (
    <Helmet>
      <link rel="canonical" href="https://renegociacao.itau.com.br/" />

      {/**
       * dns-prefetch should be used with all third-party resources,
       * even the non-critical ones.
       */}
      <link rel="dns-prefetch" href="https://www.itau.com.br" />
      <link rel="dns-prefetch" href="https://cartoes.itau.com.br" />
      <link rel="dns-prefetch" href="https://s3.amazonaws.com" />
      <link rel="dns-prefetch" href="https://www.google.com" />
      <link rel="dns-prefetch" href="https://www.googletagmanager.com" />
      <link rel="dns-prefetch" href="https://www.googleadservices.com" />
      <link rel="dns-prefetch" href="https://www.google-analytics.com" />
      <link rel="dns-prefetch" href="https://www.gstatic.com" />
      <link rel="dns-prefetch" href="https://googleads.g.doubleclick.net" />
      <link rel="dns-prefetch" href="https://ad.doubleclick.net" />
      <link rel="dns-prefetch" href="https://adservice.google.com" />
      <link rel="dns-prefetch" href="https://connect.facebook.net" />
      <link rel="dns-prefetch" href="https://www.facebook.com" />
      <link rel="dns-prefetch" href="https://bam-cell.nr-data.net" />

      {/**
       * preconnect should be used just with critical third-party resources.
       * maybe we should test with others third parties listed above.
       */}
      <link rel="preconnect" href="https://cartoes.itau.com.br" />

      {/**
       * prioritize download of two of our custom fonts, aiming to
       * reduce FOUT (Flash Of Unstiled Text), which is the font family
       * flickering on page load.
       */}

      <link
        rel="preload"
        href="/static/fonts/ItauDisplay_XBold.ttf"
        as="font"
        type="font"
        crossOrigin=""
      />
      <link
        rel="preload"
        href="/static/fonts/ItauText_Rg.ttf"
        as="font"
        type="font"
        crossOrigin=""
      />
      <script type="application/ld+json" id="lp-faq">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: [
            {
              "@type": "Question",
              name: "O que é o site de Renegociação do Itaú?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "O portal de renegociação é uma plataforma online de renegociação de dívidas do Itaú. Temos como objetivo ajudar clientes do Itaú a negociar as dívidas e buscar alívio financeiro de forma simples, rápida e segura.",
              },
            },
            {
              "@type": "Question",
              name: "Quem pode renegociar no canal? Como faço para achar minhas dívidas?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "Podem renegociar clientes correntistas tanto de pessoas físicas quanto jurídicas e também clientes que possuem um Cartão Itaú ou cartões dos nossos parceiros como Credicard, Luizacred, Extra, Ponto Frio, Passaí, Marisa e Hipercard. Para fazer sua renegociação é muito fácil! Basta realizar o login no site com seu CPF, consultar as operações de crédito que podem ser renegociadas neste canal e escolher as melhores opções que cabem no seu bolso.",
              },
            },
            {
              "@type": "Question",
              name: "Consigo gerar uma segunda via do meu boleto?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "Sim! Vale lembrar que quando o pagamento não ocorre dentro do vencimento do boleto, o Banco Itaú cancela automaticamente o acordo. Dessa forma, você deverá fazer uma nova renegociação. Caso ainda esteja dentro do prazo e queira receber seu boleto novamente você pode entrar neste link: https://correspondenciasdigitais.itau.com.br/login",
              },
            },
            {
              "@type": "Question",
              name: "Quais as vantagens desse produto?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "O produto permite reequilibrar e reorganizar suas finanças, uma vez que você pode alterar o valor/quantidade de parcelas e a data de vencimento mesmo para contratos em dia. Caso esteja negativado, o produto regulariza sua situação com os órgãos de proteção ao crédito após a efetivação do pagamento do boleto da primeira parcela ou do boleto de pagamento à vista, em até 5 dias úteis.",
              },
            },
            {
              "@type": "Question",
              name: "Em quanto tempo meu nome sai dos órgãos de restrição de crédito?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "Os apontamentos cadastrais relacionados ao(s) contrato(s) negociado(s) serão retirados em até 5 dias úteis após a efetivação do acordo através do pagamento do boleto da 1ª parcela ou da quitação à vista.",
              },
            },
          ],
        })}
      </script>
    </Helmet>
  )
}

export default Head
